import { useTranslation } from "react-i18next";
import '../../StatsTable.css';

interface StatsTablesComponentProps{
    editMode: boolean, 
    // speed: {
    //     walkSpeedMt: number,
    //     walkSpeedFt: number,
    //     walkSpeedSq: number,
    //     flySpeedMt: number,
    //     flySpeedFt: number,
    //     flySpeedSq: number,
    //     swimSpeedMt: number,
    //     swimSpeedFt: number,
    //     swimSpeedSq: number,
    // },
    stats: {
        str: number,
        dex: number,
        con: number,
        int: number,
        wis: number,
        cha: number,
        strSave: number,
        dexSave: number,
        conSave: number,
        intSave: number,
        wisSave: number,
        chaSave: number,
    },
    updateValues: (
        stats: {
            str: number,
            dex: number,
            con: number,
            int: number,
            wis: number,
            cha: number,
            strSave: number,
            dexSave: number,
            conSave: number,
            intSave: number,
            wisSave: number,
            chaSave: number,
        }
    )=> void
}

const StatsTablesComponent = (props: StatsTablesComponentProps)=>{
    const { t } = useTranslation();
    return (<>
        <div className="d-flex m-3 gap-3">
            <table className=" stat-table physical">
                <thead>
                    <tr>
                        <th></th>
                        <th>{t("table-stat")}</th>
                        <th>{t("table-modifier")}</th>
                        <th>{t("table-savingthrow")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="">
                        <th>{t("table-str")}</th>
                        <td>
                            {props.editMode ?
                                <input
                                    type='number'
                                    value={props.stats.str}
                                    onChange={e => {
                                        props.stats.str = (parseInt(e.target.value));
                                        props.stats.strSave=Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            :
                                props.stats.str
                            }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.str - 11)/2) >= 0 ? "+":"")+Math.round((props.stats.str - 11)/2)}</td>
                        <td className="modifier">
                            {props.editMode ?
                                <input
                                    type='number'
                                    value={props.stats.strSave}
                                    onChange={e => {
                                        props.stats.strSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            :
                                (props.stats.strSave >= 0 ? "+":"")+props.stats.strSave
                            }
                        </td>
                    </tr>
                    <tr className="">
                        <th>{t("table-dex")}</th>
                        <td>
                            {props.editMode ?
                                <input
                                    type='number'
                                    value={props.stats.dex}
                                    onChange={e => {
                                        props.stats.dex = (parseInt(e.target.value));
                                        props.stats.dexSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            :
                                props.stats.dex
                            }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.dex - 11)/2) >= 0 ? "+" : "") + Math.round((props.stats.dex - 11)/2)}</td>
                        <td className="modifier">
                        {props.editMode ?
                            <input
                                    type='number'
                                    value={props.stats.dexSave}
                                    onChange={e => {
                                        props.stats.dexSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                        :
                            (props.stats.dexSave >= 0 ? "+":"") + props.stats.dexSave
                        }
                        </td>
                    </tr>
                    <tr className="">
                        <th>{t("table-con")}</th>
                        <td>
                            {props.editMode ?
                                <input
                                    type='number'
                                    value={props.stats.con}
                                    onChange={e => {
                                        props.stats.con = (parseInt(e.target.value));
                                        props.stats.conSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            :
                                props.stats.con
                            }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.con - 11)/2) >= 0 ? "+" : "") + Math.round((props.stats.con - 11)/2)}</td>
                        <td className="modifier">
                        {props.editMode ?
                            <input
                                type='number'
                                value={props.stats.conSave}
                                onChange={e => {
                                    props.stats.conSave = (parseInt(e.target.value));
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            (props.stats.conSave >= 0 ? "+" : "") + props.stats.conSave
                        }
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className=" stat-table mental">
                <thead>
                    <tr>
                        <th></th>
                        <th>{t("table-stat")}</th>
                        <th>{t("table-modifier")}</th>
                        <th>{t("table-savingthrow")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="">
                        <th>{t("table-int")}</th>
                        <td>
                            {props.editMode ?
                                <input
                                    type='number'
                                    value={props.stats.int}
                                    onChange={e => {
                                        props.stats.int = (parseInt(e.target.value));
                                        props.stats.intSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            :
                                props.stats.int
                            }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.int - 11)/2) >= 0 ? "+" : "") + Math.round((props.stats.int - 11)/2)}</td>
                        <td className="modifier">
                        {props.editMode ?
                            <input
                                type='number'
                                value={props.stats.intSave}
                                onChange={e => {
                                    props.stats.intSave = (parseInt(e.target.value));
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            (props.stats.intSave >= 0 ? "+" : "") + props.stats.intSave        
                        }
                        </td>
                    </tr>
                    <tr className="">
                        <th>{t("table-wis")}</th>
                        <td>
                        {props.editMode ? 
                            <input
                                type='number'
                                value={props.stats.wis}
                                onChange={e => {
                                    props.stats.wis = (parseInt(e.target.value));
                                    props.stats.wisSave = Math.round((parseInt(e.target.value)- 11)/2);
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            props.stats.wis
                        }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.wis - 11)/2) >= 0 ? "+" : "") + Math.round((props.stats.wis - 11)/2)}</td>
                        <td className="modifier">
                        {props.editMode ? 
                            <input
                                type='number'
                                value={props.stats.wisSave}
                                onChange={e => {
                                    props.stats.wisSave = (parseInt(e.target.value));
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            (props.stats.wisSave >= 0 ? "+" : "")+props.stats.wisSave
                        }
                        </td>
                    </tr>
                    <tr className="">
                        <th>{t("table-cha")}</th>
                        <td>
                        {props.editMode ? 
                            <input
                                type='number'
                                value={props.stats.cha}
                                onChange={e => {
                                    props.stats.cha = (parseInt(e.target.value));
                                    props.stats.chaSave = Math.round((parseInt(e.target.value)- 11)/2);
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            props.stats.cha
                        }
                        </td>
                        <td className="modifier">{(Math.round((props.stats.cha - 11)/2) >= 0 ? "+" : "") + Math.round((props.stats.cha - 11)/2)}</td>
                        <td className="modifier">
                        {props.editMode ?
                            <input
                                type='number'
                                value={props.stats.chaSave}
                                onChange={e => {
                                    props.stats.chaSave = (parseInt(e.target.value));
                                    props.updateValues(props.stats);
                                }}
                            />
                        :
                            (props.stats.chaSave >= 0 ? "+" : "") + props.stats.chaSave
                        }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        {/* <div className="stat-row-horiz p-3" >   
            <div className="stat-row-horiz col-8 p-1">
                <table className='table-small table-bordered ' style={{textAlign: "center"}}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t("table-str")}</th>
                            <th>{t("table-dex")}</th>
                            <th>{t("table-con")}</th>
                            <th>{t("table-int")}</th>
                            <th>{t("table-wis")}</th>
                            <th>{t("table-cha")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="table-row">
                            <td>{t("table-stat")}</td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.str}
                                    onChange={e => {
                                        props.stats.str = (parseInt(e.target.value));
                                        props.stats.strSave=Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.dex}
                                    onChange={e => {
                                        props.stats.dex = (parseInt(e.target.value));
                                        props.stats.dexSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.con}
                                    onChange={e => {
                                        props.stats.con = (parseInt(e.target.value));
                                        props.stats.conSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />

                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.int}
                                    onChange={e => {
                                        props.stats.int = (parseInt(e.target.value));
                                        props.stats.intSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.wis}
                                    onChange={e => {
                                        props.stats.wis = (parseInt(e.target.value));
                                        props.stats.wisSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.cha}
                                    onChange={e => {
                                        props.stats.cha = (parseInt(e.target.value));
                                        props.stats.chaSave = Math.round((parseInt(e.target.value)- 11)/2);
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr className="table-row">
                            <td>{t("table-modifier")}</td>
                            <td>
                                {Math.round((props.stats.str - 11)/2)}
                            </td>
                            <td>
                                {Math.round((props.stats.dex - 11)/2)}
                            </td>
                            <td>
                                {Math.round((props.stats.con - 11)/2)}
                            </td>
                            <td>
                                {Math.round((props.stats.int - 11)/2)}
                            </td>
                            <td>
                                {Math.round((props.stats.wis - 11)/2)}
                            </td>
                            <td>
                                {Math.round((props.stats.cha - 11)/2)}
                            </td>
                        </tr>
                        <tr className="table-row">
                            <td>{t("table-savingthrow")}</td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.strSave}
                                    onChange={e => {
                                        props.stats.strSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.dexSave}
                                    onChange={e => {
                                        props.stats.dexSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.conSave}
                                    onChange={e => {
                                        props.stats.conSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />

                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.intSave}
                                    onChange={e => {
                                        props.stats.intSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.wisSave}
                                    onChange={e => {
                                        props.stats.wisSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    type='number'
                                    value={props.stats.chaSave}
                                    onChange={e => {
                                        props.stats.chaSave = (parseInt(e.target.value));
                                        props.updateValues(props.stats);
                                    }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> */}
        </>
    )
}

export default StatsTablesComponent;